import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    dialog: {
      textAlign: 'left',
      direction: 'ltr',
      padding: theme.spacing(2),
      lineHeight: 2,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    continueBtn:{
      padding: '0 10px',
      height: '28px',
      margin: '6px 0',
      fontSize: '12px',
    },
    cancelButton: {
      marginLeft: '5px',
    },
    information: {
      display: 'flex',
      gap: '8px',
      width: '363px',
      alignItems: 'center',
      textAlign: 'justify',
      margin: '25px 0 40px',
    },
    descriptionSuccess: {
      fontSize: '13px',
      lineHeight: '25px',
      fontWeight: 'bold',
      background: '#2b39900f',
      padding: '10px',
      borderRadius: '6px',
    },
    descriptionPending: {
      fontSize: '13px',
      lineHeight: '25px',
      fontWeight: 'bold',
      background: '#2b39900f',
      padding: '10px',
      borderRadius: '6px',
    },
    descriptionIgnore: {
      fontSize: '13px',
      lineHeight: '25px',
      fontWeight: 'bold',
      background: '#2b39900f',
      padding: '10px',
      borderRadius: '6px',
    },
    loadingFinger:{
      margin: '40px auto',
      textAlign: 'center'
    },
    direction: {
      direction: 'ltr!important',
    },
    addButton: {
      [theme.breakpoints.up('md')]: {
        transform: 'translate(5px, 31px)',
      },
    },
    isLoading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '16px 0',
    },
    isError: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      margin: '16px 0',
    },
    titleCategory: {
      fontWeight: 'bold',
      fontSize: '13px',
    },
    subItem: {
      fontSize: '12px',
      display: 'flex',
      //alignItems: 'center',
    },
    iconStyle: {
      //opacity: '0.4',
      width: '0.8em',
      height: '0.8em',
      border: '1px solid #ccc',
      backgroundColor: '#e5e5e5',
      borderRadius: '50%',
    },
    iconTop: {
      color: 'white',
      backgroundColor: '#2B3990',
    },
    fonticon8: {
      width: '0.7em',
      height: '0.7em',
      color: '#43a047',
      margin: '0 4px',
      marginTop: '4px',
    },
    headItem: {
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
      backgroundColor: '#f4f4f4',
      padding: '10px',
      borderRadius: '4px',
      fontSize: '12px',
    },
    collpaseContent: {
      //border:'1px solid #f4f4f4',
      borderTop: 'none',
      //borderRadius: '4px',
      //boxShadow:'3px 7px 12px -4px #f4f4f4',
      //boxShadow: '-2px 3px 10px 0px #f2ebeb',
      margin: '0 2px',
      minHeight: '180px',
    },
    mr8: {
      marginRight: '8px',
    },
    mr4: {
      marginRight: '4px',
      padding: '8px',
      marginTop: '12px',
      minHeight: '100px',
    },
    pd16: {
      padding: '16px !important',
    },
    download: {
      display: 'flex',
      gap: '4px',
      color: '#2b3990',
      fontWeight: '700',
      alignItems: 'center',
    },
    blockDownload: {
      display: 'block',
      width: '100%',
      margin: '13px 0 6px',
    },
    blockCard: {
      margin: '8px 0',
      borderRadius: '8px',
      border: '1px solid #2b3990',
      overflow: 'hidden',
      width: '350px',
      padding: '0',
    },
    blockCardHeader: {
      height: '45px',
      lineHeight: '45px',
      backgroundColor: '#2b3990',
      padding: ' 0 10px',
    },
    blockCardFooter: {
      height: '40px',
      lineHeight: '38px',
      backgroundColor: '#cccccc47',
      padding: ' 0 10px',
      marginTop: '12px',
      textAlign: 'center',
      borderTop: ' 1px solid #e5e5e5',
    },
    blockCardFooterHasBtn: {
      height: '40px',
      lineHeight: '38px',
      justifyContent: 'space-between',
      display: 'flex',
      gap: '17px',
      backgroundColor: '#cccccc47',
      padding: ' 0 10px',
      marginTop: '12px',
      textAlign: 'center',
      borderTop: ' 1px solid #e5e5e5',
    },
    blockCardFooterTitle: {
      fontSize: '12px',
      color: '#2b3990',
    },
    blockCardTitle: {
      fontSize: '13px',
      color: '#fff',
      fontWeight: 'bold',
    },
    btnSabt: {
      width: '97%',
      [theme.breakpoints.down('lg')]: {
        width: '97%',
      },
      [theme.breakpoints.down('sm')]: {
        width: '93%',
      },
    },
  };
});
